import { isNil, isArray } from 'lodash';

/*
 |------------------------------------------------------------------------------
 | Enhanced ecommerce - Promotions
 |------------------------------------------------------------------------------
 */

export function fillItem(brand, item, list, index) {
	const result = {
		item_name: item.Name,
		item_id: item.CourseNumber,
		price: item.Fee,
		item_brand: brand,
		item_category: item.City || item.category || '',
		item_category2: item.category2 || '',
		item_category3: item.category3 || '',
		item_category4: item.category4 || '',
		item_category5: item.category5 || '',
		item_variant: '',
		index: index,
		quantity: 1
	}

	if (list) {
		result.item_list_name = list.name;
		result.item_list_id = list.id;
    }

	return result;
}

export function pushDataLayer(event, items, customFields) {
	// reset dataLayer element
	window.dataLayer.push({
		ecommerce: null
	});

	// items should be a collection of 0..n items
	if (!isNil(items) && !isArray(items)) {
		items = [items];
	};

	window.dataLayer.push({
		event: event,
		ecommerce: {
			...customFields,
			items: items
		}
	});
}